import { IAdvancedRole } from '../models/advancedRole.model';
import { IFeature } from '../models/features.model';

import { IBaseAction, IErrorAction } from '../../../../store/types/base.state';

export const AccessControlActionsValues = {
  GET_ACCONFIG: 'GET_ACCONFIG',
  GET_ACCONFIG_FAILED: 'GET_ACCONFIG_FAILED',
  GET_ACCONFIG_SUCCESS: 'GET_ACCONFIG_SUCCESS',
} as const;
export type TAccessControlActionTypes = (typeof AccessControlActionsValues)[keyof typeof AccessControlActionsValues];

export interface IACGetConfigAction extends IBaseAction {
  type: typeof AccessControlActionsValues.GET_ACCONFIG;
}

export interface IACGetConfigSuccessAction extends IBaseAction {
  type: typeof AccessControlActionsValues.GET_ACCONFIG_SUCCESS;
  config: IAdvancedRole<IFeature>[];
  features: IFeature[];
  option?: {
    actions: string[];
  };
}
export interface IACGetConfigFailedAction extends IErrorAction {
  type: typeof AccessControlActionsValues.GET_ACCONFIG_FAILED;
}

export type TAccessControlActions = IACGetConfigAction | IACGetConfigSuccessAction | IACGetConfigFailedAction;
